import styled from 'styled-components'

export const ButtonLabel = styled.div`
	display: flex;
	column-gap: 8px;
	align-items: center;
	justify-content: center;
`
